import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function Codes(props) {
    const params = useParams();
    if (params.id) {
        return <Edit id={params.id} {...props} />;
    }
    return <List {...props} />;
}

function List({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:game:codes", { game_id: gameId }));
    const { setDelData } = useAppContext();

    if (!apiData) return;

    const headerTools = (
        <Link
            to={url_reverse("games:code:edit", { game_id: gameId, code_id: "upload" })}
            className="btn btn-sm btn-dark"
        >
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <div className="mb-3">
                <Table bordered>
                    <tbody>
                        <tr>
                            <th>{t("Всего ключей загружено")}</th>
                            <td>{apiData.info.total}</td>
                        </tr>
                        <tr>
                            <th>{t("Ключей в продаже")}</th>
                            <td>{apiData.info.total - apiData.info.reserve - apiData.info.buy}</td>
                        </tr>
                        <tr>
                            <th>{t("Ключей зарезервировано")}</th>
                            <td>{apiData.info.reserve}</td>
                        </tr>
                        <tr>
                            <th>{t("Ключей куплено")}</th>
                            <td>{apiData.info.buy}</td>
                        </tr>
                    </tbody>
                </Table>
                <a
                    className="btn btn-danger"
                    onClick={() =>
                        setDelData({
                            url: apiUrl,
                            afterRespOK: (resp) => {
                                setApiData(resp);
                            },
                        })
                    }
                >
                    {t("Удалить ключи в продаже")}
                </a>
            </div>

            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Загрузил")}</th>
                        <th>{t("Время загрузки")}</th>
                        <th>{t("Статус загрузки")}</th>
                        <th>{t("Ключей в файле")}</th>
                        <th>{t("Ключей добавлено")}</th>
                        <th>{t("Цена закупки одного ключа")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>{o.email}</td>
                                <td>{o.date}</td>
                                <td>{o.status}</td>
                                <td>{o.total}</td>
                                <td>{o.added}</td>
                                <td>{o.code_price}</td>
                                <td className="dmg-table-row-tools">
                                    <Link to={url_reverse("games:code:edit", { game_id: gameId, code_id: o.id })}>
                                        <Awesome type="pencil" />
                                    </Link>{" "}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, gameId, header }) {
    const { apiData } = useAppApi(url_reverse("api:game:codes:edit", { game_id: gameId, code_id: id }));

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse("games:code:list", { game_id: gameId })} />
        </CommonCard>
    );
}
